function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgUpload = function SvgUpload(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("g", {
    id: "surface339626"
  }, React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fillOpacity: 1
    },
    d: "M 29.167969 33.332031 L 29.167969 16.667969 L 37.5 16.667969 L 25 4.167969 L 12.5 16.667969 L 20.832031 16.667969 L 20.832031 33.332031 C 20.832031 34.484375 21.765625 35.417969 22.917969 35.417969 L 27.082031 35.417969 C 28.234375 35.417969 29.167969 34.484375 29.167969 33.332031 Z M 29.167969 33.332031 "
  }), React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 2.000625 21 L 21.999375 21 ",
    transform: "matrix(2.083333,0,0,2.083333,0,0)"
  }));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgUpload, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/upload.5cd01fb0.svg";
export { ForwardRef as ReactComponent };